import React from "react";
import { Button, Tooltip } from "@mui/material";
import RefreshTwoToneIcon from "@mui/icons-material/RefreshSharp";

export default function CustomizedDialogs(props) {
  
  const handleRefresh = () => {
    window.location.reload();
  };

  return (
    <div>
      <Tooltip title="Refresh" arrow>
        <Button
          sx={{ 
            mx: 0.5,
            height: { xs: "26px", sm: "30px" },
            width: { xs: "26px", sm: "30px" },
            minWidth: 'auto',
            marginBottom: { xs: "3px", sm: "5px" },
            marginTop: { xs: "-18px", sm: "-20px" },
            borderRadius: '50px',
            boxShadow: '0 2px 4px rgba(0,0,0,0.2)',
            p: 0,
          }}
          variant="contained"
          onClick={handleRefresh}
          aria-label="refresh"
        >
          <RefreshTwoToneIcon sx={{ fontSize: { xs: "1rem", sm: "1.1rem" } }} />
        </Button>
      </Tooltip>
    </div>
  );
}
